import { InventoryTransaction } from '../knitting/kntiting-requistion-report';

export enum FinishingToRollingTransferStatus {
  Draft = 0,
  ReadyForTransfer = 1,
  InRoute = 2,
  Received = 3,
  Voided = 4,
}

export interface EntityKey {
  reference: string;
  number: string;
  entityDefinitionCode: number;
}

export interface FinishingToRollingTransfer {
  id: string;
  number: string;
  status: FinishingToRollingTransferStatus;
  initiator: EntityKey;
  rollNumbers: string[];
  inventoryTransactions: InventoryTransaction[];
}
